// The same name rules the Nova service enforces: two category names are the same when they match
// after trimming and ignoring case, and the category named "Default" is recognised the same way.
export function normaliseCategoryName(name: string): string {
	return name.trim().toLowerCase();
}

export function isDefaultCategoryName(name: string): boolean {
	return normaliseCategoryName(name) === 'default';
}

// Uncategorised is the system's own group. Its row is created only when first needed, so it may be
// missing from the catalogue, but the service treats its name as taken regardless.
export function isReservedCategoryName(name: string): boolean {
	return normaliseCategoryName(name) === 'uncategorised';
}

// The code the API puts at the start of the error when the service refuses a name that already
// exists.
export const CATEGORY_NAME_TAKEN = 'NOVA_CATEGORY_NAME_TAKEN';

export function categoryNameTakenError(): Error {
	return Object.assign(new Error('category name already exists'), {code: CATEGORY_NAME_TAKEN});
}

export function isCategoryNameTakenError(error: unknown): boolean {
	return error instanceof Error && (error as Error & {code?: string}).code === CATEGORY_NAME_TAKEN;
}
